var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.00043C15 8.17318 14.3272 7.50043 13.5 7.50043H12.75V5.25043C12.75 3.18268 11.0677 1.50043 8.99997 1.50043C6.93222 1.50043 5.24997 3.18268 5.24997 5.25043V7.50043H4.49997C3.67272 7.50043 2.99997 8.17318 2.99997 9.00043V15.0004C2.99997 15.8277 3.67272 16.5004 4.49997 16.5004H13.5C14.3272 16.5004 15 15.8277 15 15.0004V9.00043ZM6.74997 5.25043C6.74997 4.00993 7.75947 3.00043 8.99997 3.00043C10.2405 3.00043 11.25 4.00993 11.25 5.25043V7.50043H6.74997V5.25043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7124124e092972c5fa5ca9decc73d4f7.svg";
export { ForwardRef as ReactComponent };